export default __webpack_public_path__ + "83220a5a805c56ac9b9deb5d1477db73.png";